import createAction from "../../app/createAction";
import {
    BONUSES_SET_ACTIVE_FAILURE,
    BONUSES_SET_ACTIVE_START,
    BONUSES_SET_ACTIVE_SUCCESS,
    BONUSES_SET_AVAILABLE,
    CLEAR_BONUSES,
    GET_NEW_LIFE_ACCOUNTS_FAILURE,
    GET_NEW_LIFE_ACCOUNTS_START,
    GET_NEW_LIFE_ACCOUNTS_SUCCESS,
    SET_NEW_LIFE_RESPAWN_BANNER_OPENED,
    SET_NEW_LIFE_RESPAWN_FAILURE,
    SET_NEW_LIFE_RESPAWN_START,
    SET_NEW_LIFE_RESPAWN_SUCCESS,
    SET_WELCOME_APPLY_BONUS,
    SET_WELCOME_BANNER_OPENED,
} from "./bonusesConstants";

export const bonusesSetActiveListStart = (payload) => createAction(BONUSES_SET_ACTIVE_START, payload);
export const bonusesSetActiveListSuccess = (payload) => createAction(BONUSES_SET_ACTIVE_SUCCESS, payload);
export const bonusesSetActiveListFailure = (payload) => createAction(BONUSES_SET_ACTIVE_FAILURE, payload);

export const bonusesSetAvailableList = (payload) => createAction(BONUSES_SET_AVAILABLE, payload);

export const clearBonusesAction = (payload) => createAction(CLEAR_BONUSES, payload);

export const setWelcomeApplyBonusAction = (payload) => createAction(SET_WELCOME_APPLY_BONUS, payload);
export const setWelcomeBannerOpenedAction = (payload) => createAction(SET_WELCOME_BANNER_OPENED, payload);

export const getNewLifeAccountsAction = (payload) => createAction(GET_NEW_LIFE_ACCOUNTS_START, payload);
export const getNewLifeAccountsSuccess = (payload) => createAction(GET_NEW_LIFE_ACCOUNTS_SUCCESS, payload);
export const getNewLifeAccountsFailure = (payload) => createAction(GET_NEW_LIFE_ACCOUNTS_FAILURE, payload);

export const setNewLifeRespawnAction = (payload) => createAction(SET_NEW_LIFE_RESPAWN_START, payload);
export const setNewLifeRespawnSuccess = (payload) => createAction(SET_NEW_LIFE_RESPAWN_SUCCESS, payload);
export const setNewLifeRespawnFailure = (payload) => createAction(SET_NEW_LIFE_RESPAWN_FAILURE, payload);

export const setNewLifeRespawnBannerOpened = (payload) => createAction(SET_NEW_LIFE_RESPAWN_BANNER_OPENED, payload);
